import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { IDisputesAlertProviders } from '../../payments/payments-interfaces';
import { TableCell } from '../../../components/table/TableCell';
import { RELATED_ENTITY_TYPE, RelatedEntityNameLink } from '../../../components/merchants/RelatedEntityNameLink';
import React, { FC } from 'react';
import clsx from 'clsx';

export enum DisputesAlertProvidersTableAccessorKeys {
  partnerId = 'partnerId',
  providerId = 'name',
  connectedGateways = 'connectedGateways',
  isEthocaProvider = 'isEthocaProvider',
  isRdrProvider = 'isRdrProvider',
  isChargebacksManagementProvider = 'isChargebacksManagementProvider',
  isActive = 'isActive',
}

export const defaultDisputesAlertProvidersColumnSizing: ColumnSizing = {
  [DisputesAlertProvidersTableAccessorKeys.partnerId]: 100,
  [DisputesAlertProvidersTableAccessorKeys.providerId]: 100,
  [DisputesAlertProvidersTableAccessorKeys.connectedGateways]: 50,
  [DisputesAlertProvidersTableAccessorKeys.isEthocaProvider]: 50,
  [DisputesAlertProvidersTableAccessorKeys.isRdrProvider]: 50,
  [DisputesAlertProvidersTableAccessorKeys.isChargebacksManagementProvider]: 50,
  [DisputesAlertProvidersTableAccessorKeys.isActive]: 50,
};

export const defaultDisputesAlertProvidersColumns: MRT_ColumnDef<IDisputesAlertProviders>[] = [
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.partnerId,
    header: 'Partner',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Partner</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        <RelatedEntityNameLink id={renderedCellValue} type={RELATED_ENTITY_TYPE.PARTNER} />
      </TableCell>
    )
  },
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.providerId,
    header: 'Provider',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Provider</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        {renderedCellValue ?? '-'}
      </TableCell>
    )
  },
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.connectedGateways,
    header: 'Connected gateways',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Connected gateways</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        {renderedCellValue ?? '-'}
      </TableCell>
    )
  },
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.isEthocaProvider,
    header: 'Ethoca',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Ethoca</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        {/*{renderedCellValue && <FontAwesomeIcon icon={faSquareCheck} width={20} className="text-danger h-20px"/>}*/}
        <AlertProvidersCheckbox
          checked={renderedCellValue}
          readonly
        />
      </TableCell>
    )
  },
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.isRdrProvider,
    header: 'RDR',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">RDR</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        {/*{renderedCellValue && <FontAwesomeIcon icon={faSquareCheck} width={20} className="text-danger h-20px"/>}*/}
        <AlertProvidersCheckbox
          checked={renderedCellValue}
          readonly
        />
      </TableCell>
    )
  },
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.isChargebacksManagementProvider,
    header: 'Chargeback',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Chargeback</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        {/*{renderedCellValue && <FontAwesomeIcon icon={faSquareCheck} width={20} className="text-danger h-20px"/>}*/}
        <AlertProvidersCheckbox
          checked={renderedCellValue}
          readonly
        />
      </TableCell>
    )
  },
  {
    accessorKey: DisputesAlertProvidersTableAccessorKeys.isActive,
    header: 'Active',
    enableSorting: false,
    Header: <span className="text-muted main-font-family fs-9">Active</span>,
    Cell: ({ renderedCellValue, table }: any): JSX.Element => (
      <TableCell
        additionalClass="main-font-family text-black"
        density={table?.options?.state?.density}
        isTextOverflow={true}
      >
        {/*{renderedCellValue && <FontAwesomeIcon icon={faSquareCheck} width={20} className="text-danger h-20px"/>}*/}
        <AlertProvidersCheckbox
          checked={renderedCellValue}
          readonly
        />
      </TableCell>
    )
  },
];

interface Props {
  isDisabled?: boolean;
  onChange?: () => void;
  checked: boolean;
  readonly?: boolean;
}

const AlertProvidersCheckbox: FC<Props> = (props) => {
  const { isDisabled, onChange, checked, readonly } = props;
  return (
    <div className='form-check form-check-sm form-check-custom form-check-solid'>
      <input
        className={clsx(
          'form-check-input',
          isDisabled && 'cursor-not-allowed',
          readonly && 'readonly'
        )}
        type='checkbox'
        checked={checked}
        onChange={onChange}
        disabled={isDisabled}
        readOnly={readonly}
      />
    </div>
  );
};